import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableLayoutType, TableRow, TextRun, WidthType } from "docx";

export function scope(certInApplicationUrl, certInAppDescription, criticality) {
    return new Table({
        width: { size: 105, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        layout: TableLayoutType.FIXED,
        spacing: { before: 600 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Sl No.",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 17, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Asset Description",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 11, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Criticality of Asset",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Internal IP Address",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Operating Software",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Public IP Address",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Location",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Hash Value (in case of applications)",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        indent: { left: 50, right: 50 },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 20 },
                                children: [
                                    new TextRun({
                                        text: "Application Version (Android & iOS)",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                spacing: { after: 200 },
                                children: [
                                    new TextRun({
                                        text: "Other details such as make and model in case of network devices or security devices",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 17, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: certInAppDescription,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 11, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: criticality,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        children: certInApplicationUrl.split(/\s+/).map((url) =>
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Android",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })
                        ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        indent: { left: 50, right: 50 },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 20 },
                                children: [
                                    new TextRun({
                                        text: "Android-v1.0",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                spacing: { after: 200 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

        ]
    })
}